import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash/get';

import VerticalBookCardList from 'rebook/apps/books/components/VerticalBookCardList';
import numberWithSpace from 'rebook/apps/utils/text/numberWithSpace';
import pluralize from 'rebook/apps/utils/text/pluralize';

import styles from './style.scss';


const BooksCarousel = ({ bookList, bookCount, title, link, type }) => {
  return (
    <div className="billetContainerNoOverflow">
      <div className="billetContainerWrapper">
        {get(bookList, 'length')
          ? (
            <div className={styles.name}>
              <div>
                <div className={styles.title}>{title}</div>
                <span className={styles.subtitle}>
                  {`${numberWithSpace(bookCount)} ${type}${pluralize(bookCount, 'книга', 'книги', 'книг')}`}
                </span>
              </div>
              <div>
                <Link to={link}>
                  <span className={classNames('link', styles.linkName)}>
                    {`Все ${type}книги`}
                  </span>
                  <span className="shortArrow" />
                </Link>
              </div>
            </div>
          )
          : (
            <React.Fragment>
              <div className={styles.titleEmpty} />
              <div className={styles.subTitleEmpty} />
            </React.Fragment>
          )}
      </div>
      <VerticalBookCardList bookList={bookList} />
    </div>
  );
};

BooksCarousel.propTypes = {
  bookList: PropTypes.arrayOf(PropTypes.object),
  bookCount: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  title: PropTypes.string.isRequired,
  link: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      pathname: PropTypes.string,
      state: PropTypes.object,
    }),
  ]).isRequired,
  type: PropTypes.string,
};

BooksCarousel.defaultProps = {
  bookList: null,
  type: '',
};

export default BooksCarousel;
